import Category from './category';
import { ICategory, ServiceState } from '../../rz-status_models';
import { useFilter } from '../contextProviders/FilterContext';

export default function({data, hideState = false}:{data: ICategory[], hideState: boolean}) {
  const {setFilter} = useFilter();
  if(data && data.length > 0) {
      return <ul id="overview" aria-label="Servicestatusübersicht nach Kategorie">
        {data.map((res) => <Category key={res.id} category={res} hideState={hideState}/>)}
  </ul>
  }
  else {
    return <div id="overview" className="empty">
      <h2>Keine Ergebnisse für die eingestellten Filter</h2>
      <p>Passen Sie Ihre Filter an, um ein Ergebnis zu erhalten.</p>
      <button onClick={() => setFilter([ServiceState.Available, ServiceState.Maintanance, ServiceState.Limited, ServiceState.Outage])}>Filter zurücksetzen</button>
    </div>
  }
}